import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { PopupState } from 'src/domains/layouts/state/popupState/PopupState';
import { UsersState } from 'src/domains/players/state/UsersState';
import { IdentityState } from 'src/domains/players/state/IdMission/IdentityState';
import { NonBlockingNotificationsState } from 'src/domains/players/state/NonBlockingNotification.state';
import { NonBlockingNotificationType } from 'src_server/trpc/types/accountModel/accountResponse';

const PopupsWithStartApp = ssrReactLazy(
    async () =>
        (await import(/* webpackPrefetch: true */ 'src/domains/layouts/ui/uiComponents/PopupsWithStartApp'))
            .PopupsWithStartApp
);
const QuickBet = ssrReactLazy(
    async () =>
        (await import(/* webpackPrefetch: true */ 'src/domains/sportsbook/betting/ui/betSlip/quickBet/QuickBet'))
            .QuickBet
);
const PopupContainer = ssrReactLazy(
    async () => (await import('src/domains/layouts/webview/components/popups/PopupContainer')).PopupContainer
);
const NonBlockingNotifications = ssrReactLazy(
    async () =>
        (await import('src/domains/players/webview/components/Account/Notifications/NonBlockingNotifications'))
            .NonBlockingNotifications
);
const SrgQuestionnaire = ssrReactLazy(
    async () =>
        (await import('src/domains/players/state/srgQuestionnaire/srgQuestionnaire/SrgQuestionnaire')).SrgQuestionnaire
);
const IdMission = ssrReactLazy(
    async () => (await import('src/domains/players/state/IdMission/IdMissionPopup/IdMissionPopup')).IdMission
);
const PofPopups = ssrReactLazy(
    async () => (await import('src/domains/players/webview/components/PofPopups/PofPopups')).PofPopups
);

export const AppPopupsLayer = observer('AppPopupsLayer', () => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;

    const { srgQuestionnaire: isSrgQuestionnaire, pofModals } = config;

    const { popupForView } = PopupState.get(common);
    const usersState = UsersState.get(common);
    const identityState = IdentityState.get(common);
    const nonBlockingNotificationsState = NonBlockingNotificationsState.get(common);

    const identityStateProcessIdMissionIsOpen = identityState?.processIdMission.isOpen ?? false;
    const nonBlockingNotificationType = nonBlockingNotificationsState.getNonBlockingNotificationType;

    return (
        <>
            <React.Suspense fallback={null}>
                <PopupsWithStartApp />
            </React.Suspense>
            <React.Suspense fallback={null}>
                <QuickBet />
            </React.Suspense>

            {popupForView === null ? null : (
                <React.Suspense fallback={null}>
                    <PopupContainer />
                </React.Suspense>
            )}

            {nonBlockingNotificationType === null ? null : (
                <React.Suspense fallback={null}>
                    <NonBlockingNotifications
                        nonBlockingNotificationType={NonBlockingNotificationType.REVIEW_ACCOUNT}
                    />
                </React.Suspense>
            )}

            {usersState.isSrgModalOpen && isSrgQuestionnaire ? (
                <React.Suspense fallback={null}>
                    <SrgQuestionnaire />
                </React.Suspense>
            ) : null}

            {identityStateProcessIdMissionIsOpen ? (
                <React.Suspense fallback={null}>
                    <IdMission />
                </React.Suspense>
            ) : null}

            {pofModals ? (
                <React.Suspense fallback={null}>
                    <PofPopups />
                </React.Suspense>
            ) : null}
        </>
    );
});
